import React, { PureComponent } from 'react'
import { Popup, Button, Checkbox, Table } from 'semantic-ui-react'
import firebase from 'firebase/app'
import get from 'lodash/get'

import utils from '../../../../../utils'

export default class SwitchDriver extends PureComponent {
  state = {
    visible: false,
    switching: false,
    selectAll: false,
    selectedOrders: [],
  }

  componentDidMount() {
    const { order, delivererInProgressOrders } = this.props

    if (delivererInProgressOrders.length > 1) {
      this.setState({ selectedOrders: [order] })
    }
  }

  getOrders = () => {
    const { order } = this.props
    const { selectedOrders } = this.state

    const queueOrderUids = []

    selectedOrders.forEach(selectedOrder => {
      if (selectedOrder.key !== order.key) queueOrderUids.push(selectedOrder.key)
    })

    return {
      main: order,
      queue: queueOrderUids.length > 0 ? queueOrderUids : null,
    }
  }

  onSwitchManualClick = () => {
    const { showSwitchDriver, readOnly } = this.props

    if (!readOnly) this.setState({ visible: false }, () => showSwitchDriver(this.getOrders()))
  }

  onSwitchRandomClick = async () => {
    try {
      const { readOnly } = this.props

      if (readOnly) return

      this.setState({ switching: true, visible: false })

      const { main, queue } = this.getOrders()

      const params = {
        orderUid: main.key,
        switchType: 'random',
        driverUid: main.deliverer,
        queueOrderUids: queue,
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 'switch-driver', ...params })

      this.setState({ switching: false })
    } catch (error) {
      this.setState({ switching: false })
      // eslint-disable-next-line no-alert
      alert(error.message || error)
    }
  }

  onSelectAllChange = () => {
    const { todayOrders, delivererInProgressOrders, order } = this.props
    const { selectAll: prevSelectAll } = this.state

    const selectAll = !prevSelectAll
    const selectedOrders = selectAll
      ? todayOrders.filter(({ key }) => delivererInProgressOrders.includes(key))
      : [order]

    this.setState({ selectedOrders, selectAll })
  }

  onOrderSelected = order => {
    const { selectedOrders } = this.state

    const isCurrentlySelected = selectedOrders.some(({ key }) => key === order.key)

    const newSelectedOrders = isCurrentlySelected
      ? selectedOrders.filter(({ key }) => key !== order.key)
      : selectedOrders.concat(order)

    this.setState({ selectedOrders: newSelectedOrders })
  }

  onPopupOpen = () => this.setState({ visible: true })

  onPopupClose = () => this.setState({ visible: false, selectedOrders: [] })

  renderOrder = key => {
    const { todayOrders, order: mainOrder } = this.props
    const { selectedOrders } = this.state
    const isMainOrder = mainOrder.key === key
    const order = isMainOrder ? mainOrder : todayOrders.find(o => o.key === key)

    if (!order) return null

    const orderNumber = utils.order.getOrderNumber(order)
    const merchantName = get(order, 'restaurant.name', 'N/A')
    const checked = isMainOrder || selectedOrders.find(o => o.key === key) || false

    return (
      <Table.Row>
        <Table.Cell textAlign="center">
          <Checkbox onClick={() => this.onOrderSelected(order)} checked={checked} disabled={isMainOrder} />
        </Table.Cell>
        <Table.Cell textAlign="center">{orderNumber}</Table.Cell>
        <Table.Cell textAlign="center">{merchantName}</Table.Cell>
      </Table.Row>
    )
  }

  renderSelectingOrder = () => {
    const { selectAll } = this.state
    const { driver, delivererInProgressOrders, driversGroupByPackage, order, readOnly } = this.props
    const driverName = `${driver.family_name} ${driver.first_name}`

    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', widht: 400 }}>
        <p style={{ textAlign: 'center', marginBottom: 0 }}>
          Driver <b>{driverName}</b> is handling Order Guide.
        </p>

        <Table celled size="small">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="center">
                <Checkbox onClick={this.onSelectAllChange} checked={selectAll} />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Order Number</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Merchant Name</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{delivererInProgressOrders.map(this.renderOrder)}</Table.Body>
        </Table>

        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <Button
            size="tiny"
            style={{ width: 155 }}
            onClick={this.onSwitchRandomClick}
            disabled={readOnly || (driversGroupByPackage[order.package_size] || []).length === 0}
          >
            Random
          </Button>

          <Button
            size="tiny"
            style={{ width: 155 }}
            onClick={this.onSwitchManualClick}
            disabled={readOnly || (driversGroupByPackage.all || []).length === 0}
          >
            Switch Manual
          </Button>
        </div>
      </div>
    )
  }

  renderSwitchButton = () => {
    const { order, driversGroupByPackage, readOnly } = this.props

    return (
      <React.Fragment>
        <div>
          <Button
            fluid
            size="tiny"
            onClick={this.onSwitchRandomClick}
            disabled={readOnly || (driversGroupByPackage[order.package_size] || []).length === 0}
          >
            Random
          </Button>
        </div>

        <div style={{ marginTop: 3 }}>
          <Button
            fluid
            size="tiny"
            onClick={this.onSwitchManualClick}
            disabled={readOnly || (driversGroupByPackage.all || []).length === 0}
          >
            Switch Manual
          </Button>
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { order, delivererInProgressOrders, readOnly } = this.props
    const { visible, switching } = this.state

    if (order.switching_driver) return null

    return (
      <Popup
        wide
        on="click"
        hideOnScroll
        open={visible}
        onOpen={this.onPopupOpen}
        onClose={this.onPopupClose}
        position={delivererInProgressOrders.length > 1 ? 'top center' : 'bottom center'}
        trigger={
          <Button
            size="mini"
            color="orange"
            icon="exchange"
            content="Switch"
            loading={switching}
            labelPosition="right"
            disabled={switching || readOnly}
            style={{ width: 120, margin: 0, marginTop: 5 }}
          />
        }
      >
        {delivererInProgressOrders.length > 1 ? this.renderSelectingOrder() : this.renderSwitchButton()}
        {/* {this.renderSwitchButton()} */}
      </Popup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/SwitchDriver.js